import { LuMoon, LuSun } from 'react-icons/lu';
import { useStrings } from '../tenant/TenantProvider';
import { useTheme } from '../theme/ThemeProvider';

/** One click switches between light and dark; "match the system" stays in the command palette. */
export function ThemeToggle() {
  const t = useStrings();
  const { theme, setPreference } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  const Icon = theme === 'dark' ? LuSun : LuMoon;
  const label = t(next === 'dark' ? 'nav.switchToDark' : 'nav.switchToLight');

  return (
    <button type="button" className="theme-toggle" onClick={() => setPreference(next)} aria-label={label} title={label}>
      <Icon key={theme} className="theme-toggle__icon" aria-hidden="true" />
    </button>
  );
}
